// extracted by mini-css-extract-plugin
export var completionBody = "_cn-2";
export var completionCard = "_cn-0";
export var completionFooter = "_cn-3";
export var completionTitle = "_cn-1";